import { type FC } from 'react';
import { List } from '@mui/material';

import { type Audit } from '#packages/data-collection/models/audit';

import { AuditListItem } from '#apps/client-web/features/audit/components/audit-list-item';

export type AuditListPageProps = {
  /**
   * A mapping of audit links to their corresponding audit objects.
   */
  auditsLinkMap: Record<string, Audit>;
};

export const AuditListPageRenderer: FC<AuditListPageProps> = ({
  auditsLinkMap,
}) => (
  <List sx={{ flexGrow: 1 }}>
    {Object.entries(auditsLinkMap).map(([detailsPageLink, audit]) => (
      <AuditListItem
        key={audit.id}
        audit={audit}
        detailsPageLink={detailsPageLink}
      />
    ))}
  </List>
);
